module.exports = __webpack_public_path__ + "static/media/cancel.e6a04bbe.svg";